import { createFileRoute } from '@tanstack/react-router';
import { MemberPage } from '../components/pages/MemberPage/MemberPage';

export const Route = createFileRoute('/account/members_/$customerId')({
  component: MemberPage,
});
